export const SOCIAL_PLATFORMS = {
    facebook: { label: 'Facebook', icon: 'simple-icons:facebook' },
    instagram: { label: 'Instagram', icon: 'simple-icons:instagram' },
    youtube: { label: 'YouTube', icon: 'simple-icons:youtube' },
    tiktok: { label: 'TikTok', icon: 'simple-icons:tiktok' },
    x: { label: 'X', icon: 'simple-icons:x' },
    linkedin: { label: 'LinkedIn', icon: 'simple-icons:linkedin' },
    pinterest: { label: 'Pinterest', icon: 'simple-icons:pinterest' },
    threads: { label: 'Threads', icon: 'simple-icons:threads' },
    whatsapp: { label: 'WhatsApp', icon: 'simple-icons:whatsapp' },
    telegram: { label: 'Telegram', icon: 'simple-icons:telegram' },
    snapchat: { label: 'Snapchat', icon: 'simple-icons:snapchat' },
    reddit: { label: 'Reddit', icon: 'simple-icons:reddit' },
    bluesky: { label: 'Bluesky', icon: 'simple-icons:bluesky' },
    mastodon: { label: 'Mastodon', icon: 'simple-icons:mastodon' },
} as const

type SocialPlatform = keyof typeof SOCIAL_PLATFORMS

interface StoryblokSocialLink {
    platform?: string
    url?: string | { url?: string }
    label?: string
    enabled?: boolean
}

function isSocialPlatform(platform: string): platform is SocialPlatform {
    return platform in SOCIAL_PLATFORMS
}

function safeExternalUrl(value: string | undefined) {
    try {
        const url = new URL(value?.trim() ?? '')

        return url.protocol === 'https:' ? url.href : null
    } catch {
        return null
    }
}

export function toSocialLink(item: StoryblokSocialLink, brandName: string) {
    if (item.enabled === false) {
        return null
    }

    const href = safeExternalUrl(typeof item.url === 'string' ? item.url : item.url?.url)

    if (!href) {
        return null
    }

    const platform = item.platform?.trim().toLowerCase() || 'custom'
    const platformLabel = isSocialPlatform(platform) ? SOCIAL_PLATFORMS[platform].label : 'social media'
    const label = item.label?.trim() || `Follow ${brandName} on ${platformLabel}`

    return { platform, label, href }
}

export function socialIcon(platform: string) {
    return isSocialPlatform(platform) ? SOCIAL_PLATFORMS[platform].icon : 'tabler:world'
}
